



























































































































import { Component, Vue } from 'vue-property-decorator';
import '../assets/css/SignUpPage.scss';
import { validationMixin } from 'vuelidate';
import { required, minLength, email, sameAs } from 'vuelidate/lib/validators';
import { ApiRequest, SignupRequest } from '../types/request';
import { MedTransGoConstants } from '../util/constants';
import { CommonUtils } from '../util/commonUtils';
import { ObjectFactory } from '../config/objectFactory';

@Component({
    mixins: [validationMixin],
    data() {
        return {
            firstName: '',
            lastName: '',
            email: '',
            password: '',
            confirmPassword: '',
            phone: '',
            iAgree: 'NotAccepted',
            providerType: [],
            showPasswordRequirements: false,
            passwordCriteria: {
                minLength: false,
                notEmailOrUsername: false,
                uppercase: false,
                lowercase: false,
                number: false,
                specialChar: false,
                noRepeatedChars: false,
            },
        };
    },
    validations: {
        email: {
            required,
            email,
        },
        firstName: {
            required,
            regex: (firstName) => /^[a-zA-Z ]+$/.test(firstName),
        },
        lastName: {
            required,
            regex: (lastName) => /^[a-zA-Z ]+$/.test(lastName),
        },
        password: {
        required,
        minLength: minLength(8),
        regex: (password) =>  MedTransGoConstants.PASSWORD_REGX.test(password),
    },
    confirmPassword: {
            required,
            sameAs: sameAs('password'),
        },
        phone: {
            required,
            minLength: minLength(10),
            regex: (phone: string) =>  MedTransGoConstants.PHONE_REGX.test(phone),
        },
        providerType: {
            required,
        },
    },
    methods: {
      togglePassword: CommonUtils.togglePassword,
      validatePassword(event: Event) {
        const input = event.target as HTMLInputElement;
        const password = input.value.replace(/\s/g, '');
        this.$data.password = password;
        if (!password) {
          this.$data.passwordCriteria = {
            minLength: false,
            notEmailOrUsername: false,
            uppercase: false,
            lowercase: false,
            number: false,
            specialChar: false,
            noRepeatedChars: false,
            noSpaces: false,
          };
          return;
        }
        this.$data.passwordCriteria.minLength = password.length >= 8;
        this.$data.passwordCriteria.notEmailOrUsername =
            ![this.$data.email, this.$data.firstName, this.$data.lastName].includes(password);
        this.$data.passwordCriteria.uppercase = /[A-Z]/.test(password);
        this.$data.passwordCriteria.lowercase = /[a-z]/.test(password);
        this.$data.passwordCriteria.number = /\d/.test(password);
        this.$data.passwordCriteria.specialChar = /[!@#$%^&*()\-_=+{};:,<.>]/.test(password);
        this.$data.passwordCriteria.noRepeatedChars = !/(.)\1{2,}/.test(password);
        this.$data.passwordCriteria.noSpaces = !/\s/.test(password);
      },
    },
})
export default class SignUpPage extends Vue {

    private loginUrl: string = '';
    private errors: any = [];
    private randomNumber = Math.floor(Math.random() * 9) + 1;

    private async doSignup() {
        this.errors = [];
        const iHttpService = ObjectFactory.getHttpService();
        const signupRequest: SignupRequest = {
            clientId: this.$store.state.clientId,
            fullName: this.$data.firstName + ' ' + this.$data.lastName,
            email: this.$data.email,
            phone: this.$data.phone,
            password: this.$data.password,
            scopes: this.$data.providerType,
        };
        const request: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_PARTNERS}/signup`,
            data: signupRequest,
            loaderEvent: {
                show: true,
                message: 'Signing up',
            },
        };
        const response = await iHttpService.post<any>(request);
        if (response.success && response.data) {
            const redirectTo = `/callback?${MedTransGoConstants.FIELD_NAME_TOKEN}=${response.data}`;
            location.href = redirectTo;
        } else {
            CommonUtils.showError(response);
        }
    }
    private maskPhone(phone: string) {
        return CommonUtils.phoneNumberMask(phone);
    }
}
